<template>
  <div class="history-body history-area theme-list">
    <search-header
      ref="searchHeader"
      :query="query"
      :need-input-search="needInputSearch"
      @search="search"
    />
    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      @sort-change="sortChange"
      style="width: 100%"
    >
      <el-table-column
        prop="title"
        label="专题名称"
      >
        <template slot-scope="scope">
          <span 
            v-html="scope.row.title"
            class="pointer"
            @click="toColumn(scope.row)"
          ></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="日期"
        width="150px"
        sortable="custom"
      />
    </el-table>

    <!-- 操作区和分页区 -->
    <el-pagination
      :current-page.sync="pageConfig.pageIndex"
      :page-sizes="[10, 20, 50]"
      :page-size="pageConfig.pageSize"
      :total="pageConfig.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChange"
      @current-change="pageChange"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import searchComponent from '@/components/searchComponent'
import searchHeader from '@/modules/history/history-area/search-header'

import { historyColumnService } from '@/service/httpService'
import { globalService } from '@/service/globalService'

export default {
  name: 'HistoryArea',
  components: {
    searchComponent,
    searchHeader
  },
  data () {
    return {
      tableData: [],
      pageConfig: {
        total: 0,
        pageIndex: 1,
        pageSize: 10
      },
      allData: [],
      loading: false,
      needInputSearch: false,

      // 搜索参数配置
      query: {
        beginTime: null,
        endTime: null,
        titles: [],
        mainContents: [],
        orderByPublishTime: 1,
        titleAndMainContent: []
      }
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  mounted () {
    let query = this.$route.query
    // 有两个维度是不存在于专题列表的
    if (query.type && query.content && ['tags', 'sourceNames'].indexOf(query.type) == -1) {
      this.wordSearch ({
        searchType: query.type,
        searchText: query.content
      })
    } else {
      this.loadData()
    }    
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),

    // 全局组件搜索
    wordSearch (data) {
      if (['tags', 'sourceNames'].indexOf(data.searchType) === -1) {
        this.$refs.searchHeader.search(data)
      }
    },

    // 搜索：条件搜索
    search (searchParam) {
      this.query = {
        ...this.query,
        ...searchParam
      }
      this.pageConfig.pageIndex = 1
      this.loadData()
    },

    // 关键词高亮
    highLight (query, data, key) {
      let keyword = [
        ...query.titles,
        ...query.mainContents,
        ...query.titleAndMainContent,
      ]

      let regStr = keyword.join('|')
      let reg = new RegExp(regStr, 'gim')

      if (regStr) {
        data.forEach(item => {
          item[key] = item[key].replace(reg, '<span class="hight-light-word">$&</span>')
        })
      }
    },
    pageSizeChange (val) {
      this.pageConfig.pageSize = val
      this.pageChange()
    },
    loadData () {
      let endTime = this.query.endTime

      // 如果选择了日期 在结束日期加时间点 不用默认的00:00:00
      if (endTime) {
        endTime = window.moment(this.query.endTime).format('YYYY-MM-DD') + ' 23:59:59'
        endTime = new Date(endTime)
      }

      let param = {
        searchWords: [
          ...this.query.titles, 
          ...this.query.mainContents, 
          ...this.query.titleAndMainContent
        ],
        startTime: this.query.beginTime,
        endTime: endTime
      }

      this.loading = true

      historyColumnService.openColumns(param)
        .then(res => {
          this.allData = res.data         
          this.pageConfig.total = res.data.length
          this.pageChange()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 前端分页
    pageChange () {
      let pageSize = this.pageConfig.pageSize
      let pageIndex = this.pageConfig.pageIndex
      
      let data = this.allData.filter((item, index) => {
        return (pageIndex -1)*pageSize <= index && index < pageIndex*pageSize
      })

      let dist = []
      data.forEach(item => {
        dist.push({
          id: item.Id,
          libraryType: item.LibraryType,
          title: item.Name,
          originTitle: item.Name,
          date: item.ColumnTime ? item.ColumnTime : '--'
        })
      })

      this.highLight(this.query, dist, 'title')
      this.tableData = dist
    },

    // 跳转到详情
    sortChange( sortObj) {
      const {order} = sortObj
      let noDateList = []
      let dateList = []
      
      this.allData.forEach(item => {
        item.ColumnTime ? dateList.push(item) : noDateList.push(item)
      })

      let sortFunc = (a, b) => {
        return b.ColumnTime - a.ColumnTime
      }
      if (order === 'ascending') {
        sortFunc = (a, b) => {
          return a.ColumnTime - b.ColumnTime
        }
      }
      dateList = dateList.sort(sortFunc)
      this.allData = dateList.concat(noDateList)
      this.pageConfig.pageIndex = 1
      this.pageChange()
    },
    toColumn (row) {
      const { href } = this.$router.resolve({
        path: `column/${row.libraryType}/${row.id}`,
        query: {
          title: encodeURIComponent(row.originTitle)
        }
      })
      window.open(href)
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/modules/fullLibSearch-out/themeList.vue